import {
  BreadcrumbItem,
  BreadcrumbLabel,
  BreadcrumbList,
  BreadcrumbSeparator,
  Button,
  ErrorMessage,
  Field,
  FieldGroup,
  Fieldset,
  Heading,
  Input,
  Label,
  Textarea
} from '@criteria-labs/react'
import { Service } from '@criteria-labs/docs-kit'
import { XMarkIcon } from '@heroicons/react/24/solid'
import { SubmitHandler, useForm } from 'react-hook-form'
import { PageFormBody, PageFormFooter } from '../PageForm'
import { InspectorArticle, InspectorBody, InspectorHeader } from '../article'
import { InsertServer } from '../changes/server'
import { useRouter } from '../router'
import { useDispatchChange } from '../useDispatchChange'
import { messsageFromError } from '../util/messageFromError'

type Inputs = {
  url: string
  description?: string
}

export function NewBaseURL({ service }: { service: Service }) {
  const { push } = useRouter()

  const dispatchChange = useDispatchChange()
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError
  } = useForm<Inputs>()
  const onSubmit: SubmitHandler<Inputs> = ({ url, description }) => {
    try {
      dispatchChange(new InsertServer(service.openAPI.servers?.length ?? 0, { url, description }))
      push('/')
    } catch (error) {
      setError('root', { message: messsageFromError(error) ?? 'Could not create server' })
    }
  }

  return (
    <InspectorArticle>
      <InspectorHeader className="space-y-3">
        <div className="flex items-center justify-between">
          <BreadcrumbList className="min-h-10">
            <BreadcrumbItem onClick={() => push('/')}>
              <BreadcrumbLabel>API</BreadcrumbLabel>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbLabel>New Base URL</BreadcrumbLabel>
            </BreadcrumbItem>
          </BreadcrumbList>
          <Button aria-label="Close" plain onClick={() => push('/')}>
            <XMarkIcon />
          </Button>
        </div>
        <Heading>Create a new base URL</Heading>
      </InspectorHeader>
      <InspectorBody>
        <form onSubmit={handleSubmit(onSubmit)}>
          {errors.root && <ErrorMessage className="mt-3">{errors.root.message}</ErrorMessage>}
          <PageFormBody className="space-y-8">
            <Fieldset>
              <FieldGroup>
                <Field>
                  <Label>URL</Label>
                  <Input placeholder="Enter a URL" {...register('url', { required: true })} />
                  {errors.url && <ErrorMessage>URL is required</ErrorMessage>}
                </Field>
                <Field>
                  <Label>Description</Label>
                  <Textarea placeholder="Enter a description" {...register('description')} />
                </Field>
              </FieldGroup>
            </Fieldset>
          </PageFormBody>
          <PageFormFooter>
            <Button type="submit" color="indigo">
              Create Base URL
            </Button>
          </PageFormFooter>
        </form>
      </InspectorBody>
    </InspectorArticle>
  )
}
